import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";

export const ServiceCard = ({ service, index = 0, compact = false }) => {
  const Icon = service.icon;

  return (
    <motion.article
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.58, delay: index * 0.06, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ y: -6 }}
      className="group flex h-full flex-col rounded-lg border border-brand-navy/10 bg-white p-7 shadow-sm transition-shadow duration-300 hover:shadow-editorial"
      data-testid={`service-card-${service.slug}`}
    >
      <div className="mb-8 flex items-start justify-between gap-4">
        <span className="grid h-12 w-12 place-items-center rounded-lg bg-brand-cream text-brand-navy transition-colors duration-300 group-hover:bg-brand-copper">
          <Icon className="h-5 w-5" />
        </span>
        <span className="font-serif text-4xl font-black text-brand-navy/10">{String(index + 1).padStart(2, "0")}</span>
      </div>
      <h3 className="font-serif text-2xl font-bold tracking-tight">{service.title}</h3>
      <p className={`mt-4 flex-1 text-sm leading-7 text-brand-navy/68 ${compact ? "" : "sm:text-base"}`}>
        {service.description}
      </p>
      <Link
        to="/contact"
        data-testid={`service-card-${service.slug}-cta`}
        className="mt-7 inline-flex items-center gap-2 text-sm font-extrabold text-brand-navy transition-colors duration-300 hover:text-brand-copper"
      >
        Get Immigration Help <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1" />
      </Link>
    </motion.article>
  );
};
